import { AccountFilterIcon } from './AccountFilterIcon';

/**
 * author: Michael Irigoyen
 * id 839928F4-21EA-472B-94A0-C7DFBD6C263A
 * name account-filter
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-filter.svg
 * tags
 * - Account / User 
 */
export const AccountFunnelIcon = AccountFilterIcon;
export default AccountFunnelIcon